// extracted by mini-css-extract-plugin
module.exports = {"container":"Benefit_container__3FFdY","infoContainer":"Benefit_infoContainer__3p87E","infoBody":"Benefit_infoBody__YOhTY"};